<template>
  <div :class="getClassNames">
    <div class="messageFarm__badge">
      <gl-svg-icon :icon="variant === 'success' ? 'check' : 'alert'"
                   height="16"
                   width="16"
      />
    </div>
    <div class="messageFarm__body">
      <p v-if="title" class="messageFarm__title">{{ title }}</p>
      <span v-if="message" v-html="message"/>
      <div v-else-if="this.$slots.default">
        <slot/>
      </div>

      <button v-if="closeBtn"
              @click="handleClickClose"
              class="messageFarm__btnClose">
        <gl-svg-icon icon="close"
                     height="20"
                     width="20"
        />
      </button>
    </div>
  </div>
</template>

<script>
import GlSvgIcon from '@gl/GlSvgIcon'
export default {
  name: 'GlMessage',
  components: {
    GlSvgIcon,
  },
  props: {
    variant: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    message: {
      type: String,
      required: false,
    },
    closeBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data () {
    return {
      baseClassName: 'messageFarm',
    }
  },
  computed: {
    getClassNames () {
      const baseClassName = this.baseClassName
      const typeList = [
        'success',
        'error',
        'wait',
      ]
      const typeModifier = () => typeList.indexOf(this.variant) !== -1 ? `${baseClassName}--${this.variant}` : false
      return [baseClassName, typeModifier()]
    },
  },
  methods: {
    handleClickClose () {
      this.$emit('click-close-message')
    },
  },
}
</script>

<style lang="scss">
  .messageFarm {
    $this: &;
    $notification-list: (
      ('success', #27ae60, #fff),
      ('error', #eb5757, #fff),
      ('wait', #f2c94c, #000),
    );

    background-color: #fff;
    display: flex;

    &__badge {
      align-items: center;
      color: #fff;
      display: flex;
      flex-shrink: 0;
      padding: 0 5px;
    }

    &__title {
      color: rgba(0, 0, 0, 0.87);
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      margin-bottom: 16px;
    }

    &__body {
      border: 1px solid #e0e0e0;
      border-left: 0;
      color: rgba(0, 0, 0, 0.87);
      flex-grow: 1;
      font-size: 14px;
      line-height: 24px;
      padding: 16px;
    }

    &__btnClose {
      align-self: center;
      display: flex;
      margin-left: auto;
      margin-right: 0;
      outline: none;
    }

    &__text {
      margin-bottom: 16px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    &__link {
      color: #9b51e0;
      text-decoration: underline;
    }

    @each $name, $background, $color in $notification-list {
      &--#{$name} {
        #{$this}__badge {
          background-color: $background;
          color: $color;
        }
      }
    }
  }
</style>
